import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionsV2Service } from '../../../../../services/collectionsV2.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-delivery-vehicle-config',
  templateUrl: './delivery-vehicle-config.component.html',
  styleUrls: ['./delivery-vehicle-config.component.scss'],
})
export class DeliveryVehicleConfigComponent implements OnInit {
  @Input() data;
  @Input() linkedPartners;
  @Input() areas;
  @Output() close = new EventEmitter();
  public saving = false;
  public selectedPartners: any = [];
  public selectedAreas: any = [];

  constructor(
    private collectionsService: CollectionsV2Service,
    private helpersService: HelpersService,
  ) {}

  ngOnInit() {
    console.log(this.data);
    console.log(this.linkedPartners);
    if (this.data.linkedPartners) {
      this.selectedPartners = this.data.linkedPartners.map((x) => {
        return x.partnerID.toString();
      });
    }
    if (this.data.linkedAreas) {
      this.selectedAreas = this.data.linkedAreas.map((x) => {
        return x.areaID.toString();
      });
    }
  }

  valid() {
    return (
      this.data.name &&
      this.data.maxBikes &&
      this.data.maxBikes > 0 &&
      this.selectedAreas &&
      this.selectedAreas.length > 0
    );
  }

  save() {
    this.saving = true;
    if (this.data.id) {
      this.data.linkedPartners = this.selectedPartners.map((x) => {
        return { partnerID: x };
      });
      this.data.linkedAreas = this.selectedAreas.map((x) => {
        return { areaID: x };
      });
      this.collectionsService.updateVehicle(this.data).subscribe(
        (res) => {
          this.saving = false;
          this.close.emit('');
        },
        (err) => {
          this.saving = false;
        },
      );
    } else {
      this.data.linkedPartners = this.selectedPartners.map((x) => {
        return { partnerID: x };
      });
      this.data.linkedAreas = this.selectedAreas.map((x) => {
        return { areaID: x };
      });
      this.collectionsService
        .addVehicle(this.helpersService.getPartnerId(), this.data)
        .subscribe(
          (res) => {
            this.saving = false;
            this.close.emit('');
          },
          (err) => {
            this.saving = false;
          },
        );
    }
  }
}
